import { render, staticRenderFns } from "./PremiumCouponPanel.vue?vue&type=template&id=4ca60d21&"
import script from "./PremiumCouponPanel.vue?vue&type=script&lang=ts&"
export * from "./PremiumCouponPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports